import React, { useContext, useEffect, useState } from 'react';
import i18n from '../../../i18n';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';

import { ProtectedRouteContext } from '../../Context';

import './StepProgressIndicator.scss';

export default function StepProgressIndicator(props) {
    const appDefinition = props.appDefinition;
    const currentStep = props.currentStep;
    const disabled = props.disabled;
    const setStep = props.setStep;
    const [t] = useTranslation();
    const { userSettings } = useContext(ProtectedRouteContext);
    const [lang, setLang] = useState(
        typeof userSettings?.LanguagePreference === 'string' ? userSettings.LanguagePreference : i18n.language
    );

    const selectStep = (step) => {
        if (step.isCurrent) return;
        setStep(step.stepDisplayNum - 1);
    };

    const steps = appDefinition.sections.map((a, i) => {
        let isCurrent = i === currentStep;
        let className = 'step';
        if (a.isValid) className += ' completed';
        if (isCurrent) className += ' current';

        return {
            className: className,
            isCompleted: a.isValid,
            isCurrent: isCurrent,
            name: a.name[lang],
            stepDisplayNum: i + 1,
        };
    });

    const elements = [];
    for (let i = 0; i < steps.length; i++) {
        const step = steps[i];
        elements.push(
            <div
                className={step.className}
                key={step.stepDisplayNum}
                onClick={() => {
                    selectStep(step);
                }}
            >
                <div className="name">{step.name}</div>
                <div className="num">
                    {t('General.StepNum', { num: step.stepDisplayNum })}
                    {!step.isCompleted ? null : <FontAwesomeIcon icon={faCheckCircle} />}
                </div>
            </div>
        );
        if (i + 1 < steps.length) {
            elements.push(
                <div
                    className={'between' + (step.isCompleted ? ' completed' : '')}
                    key={step.stepDisplayNum + '-bw'}
                />
            );
        }
    }

    useEffect(() => {
        if (typeof userSettings?.LanguagePreference === 'string') {
            setLang(userSettings.LanguagePreference);
        }
    }, [userSettings.LanguagePreference]);

    return <div className={'step-progress-indicator' + (disabled ? ' disabled' : '')}>{elements.map((a) => a)}</div>;
}
